const PREFIX = "SingleDataset";
export const RESET_STORE = `${PREFIX}_RESET_STORE`;
export const IS_CONTENT_LOADING = `${PREFIX}_IS_CONTENT_LOADING`;
export const IS_CARDSLIST_LOADING = `${PREFIX}_IS_CARDSLIST_LOADING`;
export const IS_LABEL_LOADING = `${PREFIX}_IS_LABEL_LOADING`;
export const IS_ISSUE_TYPE_LOADING = `${PREFIX}_IS_ISSUE_TYPE_LOADING`;
export const SET_ISSUE_DATA = `${PREFIX}_ISSUE_DATA`;
export const SET_SEVERITY_DATA = `${PREFIX}_SET_SEVERITY_DATA`;
export const SET_DATASET_SORTING_VALUE = `${PREFIX}_SET_DATASET_SORTING_VALUE`;
export const SET_SIMILARITY_DATA = `${PREFIX}_SET_SIMILARITY_DATA`;
export const SET_SIMILARITY_VERTEX = `${PREFIX}_SET_SIMILARITY_VERTEX`;
export const SET_SIMILARITY_THRESHOLDS = `${PREFIX}_SET_SIMILARITY_THRESHOLDS`;
export const SET_DATASET_LABELS = `${PREFIX}_SET_DATASET_LABELS`;
export const SET_DATASET_CONTEXTUAL_LABELS = `${PREFIX}_SET_DATASET_CONTEXTUAL_LABELS`;
export const SET_DATASET_ISSUE_TYPES = `${PREFIX}_SET_DATASET_ISSUE_TYPES`;
export const SET_CAPTIONS = `${PREFIX}_SET_CAPTIONS`;

export const SET_NAVIGATION_CLUSTER = `${PREFIX}_SET_NAVIGATION_CLUSTER`;
export const SET_NAVIGATION_CLUSTER_LOADER = `${PREFIX}_SET_NAVIGATION_CLUSTER_LOADER`;

export const SET_EXPORT_DATA = `${PREFIX}_SET_EXPORT_DATA`;
export const SET_TEMPORARY_EXPORT_DATA = "SET_TEMPORARY_EXPORT_DATA";
export const SET_TEMP_EXPORT_DATA = `${PREFIX}_SET_TEMP_EXPORT_DATA`;
export const SET_EXPORT_DATA_TIMEOUT_ID = `${PREFIX}_SET_EXPORT_DATA_TIMEOUT_ID`;

export const SET_SHOW_CART = `${PREFIX}_SET_SHOW_CART`;
export const SET_PAGINATION_METADATA_FOR_DATA = `${PREFIX}_SET_PAGINATION_METADATA_FOR_DATA`;
export const SET_PAGINATION_METADATA_FOR_CLUSTER = `${PREFIX}_SET_PAGINATION_METADATA_FOR_CLUSTER`;
export const SET_CLUSTER_METADATA_SUMMARY = `${PREFIX}_SET_CLUSTER_METADATA_SUMMARY`;
export const SET_CLUSTER_METADATA_SUMMARY_LOADING = `${PREFIX}_SET_CLUSTER_METADATA_SUMMARY_LOADING`;
export const SET_USER_TAGS = `${PREFIX}_SET_USER_TAGS`;
export const SET_CONTEXTUAL_USER_TAGS = `${PREFIX}_SET_CONTEXTUAL_USER_TAGS`;
export const SET_DATASET_TAGS = `${PREFIX}_SET_DATASET_TAGS`;
export const UPDATE_USER_TAGS = `${PREFIX}_UPDATE_USER_TAGS`;
export const IS_USER_TAG_LOADING = `${PREFIX}_IS_USER_TAG_LOADING`;

export const SET_NAVIGATION_CONTEXT = `${PREFIX}_SET_NAVIGATION_CONTEXT`;

export const SET_IS_IMAGE_UPLOADING = `${PREFIX}_SET_IS_IMAGE_UPLOADING`;

export const SET_FETCH_ERROR = `${PREFIX}_SET_FETCH_ERROR`;

export const SET_METADATA_SOURCES_LOADING = `${PREFIX}_SET_METADATA_SOURCES_LOADING`;
export const SET_DATA_METADATA_SUMMARY = `${PREFIX}_SET_DATA_METADATA_SUMMARY`;
export const SET_DATA_METADATA_SUMMARY_LOADING = `${PREFIX}_SET_DATA_METADATA_SUMMARY_LOADING`;

export const SET_AUTOCOMPLETE_SUGGESTIONS = `${PREFIX}_SET_AUTOCOMPLETE_SUGGESTIONS`;
export const SET_RECENT_SEARCHES = `${PREFIX}_SET_RECENT_SEARCHES`;
export const SET_AUTOCOMPLETE_LOADING = `${PREFIX}_SET_AUTOCOMPLETE_LOADING`;
export const SET_AUTOCOMPLETE_NO_RESULTS_FLAG = `${PREFIX}_SET_AUTOCOMPLETE_NO_RESULTS_FLAG`;

export const SET_IMAGE_PAGE_PARAMS_CONTEXT = `${PREFIX}_SET_IMAGE_PAGE_PARAMS_CONTEXT`;

export const SET_ASSIGNED_TAGS = `${PREFIX}_SET_ASSIGNED_TAGS`;
export const SET_SHOW_EXPORT_MODAL = `${PREFIX}_SET_SHOW_EXPORT_MODAL`;
export const SET_TEMPORARY_ASSIGNED_TAGS = `${PREFIX}_SET_TEMPORARY_ASSIGNED_TAGS`;

export const SET_EXPORT_PROGRESS = `${PREFIX}_SET_EXPORT_PROGRESS`;
export const SET_EXPORT_STATUS = `${PREFIX}_SET_EXPORT_STATUS`;
export const SET_SHOW_DATASET_SHARING_MENU = `${PREFIX}_SET_SHOW_DATASET_SHARING_MENU`;
export const SET_SHOW_VIEW_SHARING_MENU = `${PREFIX}_SET_SHOW_VIEW_SHARING_MENU`;
export const SET_USERS_WITH_ACCESS = `${PREFIX}_SET_USERS_WITH_ACCESS`;
export const SET_INVITED_EMAILS = `${PREFIX}_SET_INVITED_EMAILS`;

export const SET_LAST_SELECTED_INDEX = `${PREFIX}_SET_LAST_SELECTED_INDEX`;
export const SET_SCROLL_APPLIED = `${PREFIX}_SET_SCROLL_APPLIED`;
export const SET_DATA_PAGE_SCROLL_POSITION = `${PREFIX}_SET_DATA_PAGE_SCROLL_POSITION`;
export const SET_CLUSTER_PAGE_SCROLL_POSITION = `${PREFIX}_SET_CLUSTER_PAGE_SCROLL_POSITION`;

export const SET_NO_RESULTS_FOUND = `${PREFIX}_SET_NO_RESULTS_FOUND`;

export const SET_DATASET_ENRICHMENT_MODELS = `${PREFIX}_SET_DATASET_ENRICHMENT_MODELS`;
export const SET_DATASET_EXTERNAL_SOURCES = `${PREFIX}_SET_DATASET_EXTERNAL_SOURCES`;

export const SET_SAVED_VIEWS = `${PREFIX}_SET_SAVED_VIEWS`;
export const SET_SAVED_VIEWS_LOADING = `${PREFIX}_SET_SAVED_VIEWS_LOADING`;
export const SET_DUPLICATE_THRESHOLD_RANGE = `${PREFIX}_SET_DUPLICATE_THRESHOLD_RANGE`;
export const SET_REMOVED_ELEMENTS_BY_UNIQUENESS_COUNT = `${PREFIX}_SET_REMOVED_ELEMENTS_BY_UNIQUENESS_COUNT`;
export const SET_IS_UNIQUENESS_SCORE_LOADING = `${PREFIX}_IS_UNIQUENESS_SCORE_LOADING`;

//Query Filters States
export const SET_SELECTED_QUERY_MODAL = `${PREFIX}_SET_SELECTED_QUERY_MODAL`;
export const SET_SHOW_QUERY_PANEL = `${PREFIX}_SET_SHOW_QUERY_PANEL`;
export const SET_CUSTOM_METADATA = `${PREFIX}_SET_CUSTOM_METADATA`;
export const SET_CUSTOM_METADATA_LINK_OPTIONS = `${PREFIX}_SET_CUSTOM_METADATA_LINK_OPTIONS`;
export const SET_GLOBAL_MD_TYPE = `${PREFIX}_SET_GLOBAL_MD_TYPE`;
